import type { Icon } from '../../../src/lib/types'
export const mdiFileTree: Icon = {
  "id": "file-tree",
  "name": "File Tree",
  "path": "M3,3H9V7H3V3M15,10H21V14H15V10M15,17H21V21H15V17M13,13H7V18H13V20H7L5,20V9H7V11H13V13Z",
  "as": [
    "subtasks"
  ],
  "tags": [
    "Files / Folders"
  ]
}
export default mdiFileTree